<div class="user-list">
  <div class="commands">
    <app-dropdown class="dropdown" [value]="helperService.getStatusEquivalent(selectedStatus)">
      <app-dropdown-option
        class="dropdown-option"
        [ngClass]="helperService.getStatusClass(option)"
        *ngFor="let option of statusFilters; trackBy: trackByFn"
        [value]="helperService.getStatusEquivalent(option)"
        (optionSelect)="statusFilterChange(option)"
      >
        {{ helperService.getStatusEquivalent(option) }}
      </app-dropdown-option>
    </app-dropdown>

    <mat-form-field class="search-input">
      <input
        matInput
        autocomplete="off"
        placeholder="{{ 'module.userProfile.userList.searchPlaceHolder' | translate }}"
        [formControl]="searchControl"
        (keyup.enter)="onEnterKeyDown()"
      />
    </mat-form-field>
    <button class="btn btn-outline-primary search" (click)="onSearchClick()">
      <span class="fa fa-search"></span>{{ 'module.userProfile.userList.searchIcon' | translate }}
    </button>

    <div class="buttons">
      <button *ngIf="!!authService.permissions.USER_MANAGEMENT_INVITE" class="btn btn-primary -border invite" (click)="openInviteModal()">
        <span class="fa fa-user-plus"></span>{{ 'module.userProfile.userList.inviteUsersButton' | translate }}
      </button>
    </div>
  </div>

  <app-user-list-table
    [data]="users"
    (reload)="onPageChange({ index: pageNumber })"
    (sortChange)="onSortChange($event)"
    class="user-list-table"
  ></app-user-list-table>

  <div class="loader-wrapper" *ngIf="loading">
    <span class="fa fa-spinner fa-spin fa-3x"></span>
  </div>

  <app-paginator class="paginator" *ngIf="count > 0" [length]="count" [pageSize]="pageSize" (page)="onPageChange($event)" [index]="pageNumber"></app-paginator>

  <div *ngIf="!!authService.permissions.USER_DOWNLOAD_LIST && !emptyUser" class="user-list-download-area">
    <button (click)="downloadUserList()" class="btn btn-outline-primary btn-download">
      <span class="fa fa-arrow-down" aria-hidden="true"></span>
      Benutzerliste herunterladen
    </button>
  </div>

  <app-notification-card
    class="app-notification-card"
    type="info"
    text="{{ 'module.userProfile.userList.noDataAvailableText' | translate }}"
    *ngIf="!loading && count === 0"
  >
  </app-notification-card>
</div>
